import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_MEMBER = gql`
  query {
    getCurrentMember {
      _id
      type
      ganttId
      ownerCompany {
        name
        street
        city
        country
        zipCode
        houseNumber
      }
      healthInsurance {
        _id
        name
      }
      employeePersonalInfo {
        employeeNumber
      }
      profile {
        firstName
        lastName
        phoneNumber
        gender
        birthday
        displayName
      }
      account {
        _id
        email
      }
      subscriptions {
        stripeSubscriptionId
        softwarePlan {
          name
        }
        softwareModule {
          name
        }
      }
    }
  }
`;

export const useGetCurrentMemberAccount = () => {
  const { data, loading, refetch } = useQuery(GET_CURRENT_MEMBER);

  const { getCurrentMember = {} } = data || {};

  return {
    loading,
    member: getCurrentMember,
    refetch,
  };
};
